import React from "react";
import FeatherIcon from "feather-icons-react";
import { IFilterData, IMenuItem, IMainItem } from "../../@types/types";
import { ReactComponent as Enter } from "../icons/enter.svg";
import { colors } from "../../utils";
import { useAppState } from "../../context/appContex";
import { RecentSearches, MainResults } from "../common/MainSearch";

interface SearchDropDownProps {
  searchResult: IFilterData;
  searchValue: string;
}

const Notification = () => {
  return (
    <div className='notify'>
      <div>
        <span>Press</span>
        <span className='key-sm'>
          <Enter /> Enter
        </span>
        <span>to search for customers, invoices, tasks and products.</span>
      </div>
    </div>
  );
};

const QuickLinks = ({
  links,
}: {
  links: Pick<IMenuItem, "iconClass" | "targetType" | "targetUrl" | "title">[];
}) => {
  return (
    <div className='s-quick-links'>
      {links.map((link, index) => {
        if (link.targetType === "BLANK" || link.targetType === "POPUP") {
          return (
            <a
              href={link.targetUrl}
              target='_blank'
              rel='noopener noreferrer'
              key={link.targetUrl + index.toString()}
              className='s-quick-item'
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <FeatherIcon
                  icon={link.iconClass}
                  style={{ marginRight: "10px", color: colors[index] }}
                  size={16}
                />
                <span>{link.title}</span>
              </div>
              <FeatherIcon icon='chevron-right' />
            </a>
          );
        }

        return (
          <a
            href={link.targetUrl}
            key={link.targetUrl + index.toString()}
            className='s-quick-item'
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <FeatherIcon
                icon={link.iconClass}
                style={{ marginRight: "10px", color: colors[index] }}
                size={16}
              />
              <span>{link.title}</span>
            </div>
            <FeatherIcon icon='chevron-right' />
          </a>
        );
      })}
    </div>
  );
};

const SearchDropDown: React.FC<SearchDropDownProps> = ({
  searchResult,
  searchValue,
}) => {
  const { quickLinks, mainItems } = searchResult;

  const { clientCode, user } = useAppState();

  const value = sessionStorage.getItem(`recent_search_${clientCode}_${user}`);
  const recentSearches = JSON.parse(
    value ? value : JSON.stringify("")
  ) as IMainItem[];

  return (
    <div className='search-drop-down'>
      <div className='content'>
        {searchValue ? (
          <>
            <QuickLinks links={quickLinks} />
            {recentSearches && recentSearches.length ? (
              <>
                <span
                  className='s-section-header'
                  style={quickLinks.length ? { marginTop: "20px" } : {}}
                >
                  Recent searches
                </span>
                <RecentSearches recentSearches={recentSearches} />
              </>
            ) : null}
            {mainItems.length ? (
              <>
                <span
                  className='s-section-header'
                  style={recentSearches.length ? { marginTop: "20px" } : {}}
                >
                  Results in Menus
                </span>
                <MainResults
                  items={mainItems}
                  clientCode={clientCode}
                  user={user}
                  searchValue={searchValue}
                />
              </>
            ) : null}
          </>
        ) : (
          <Notification />
        )}
      </div>
    </div>
  );
};

export default SearchDropDown;
